(() => {
  const dialog = document.getElementById('AkLegalGuarantee');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  let opener;
  let parentDialog;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ak-guarantee-open]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    if (dialog.open) return;
    opener = link;
    parentDialog = link.closest('[role="dialog"], modal-dialog[open], menu-drawer');
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    dialog.showModal();
    document.documentElement.classList.add('ak-guarantee-open');
  }, true);

  dialog.addEventListener('click', (event) => {
    event.stopPropagation();
    if (event.target.closest('[data-ak-guarantee-close]')) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });

  dialog.addEventListener('cancel', (event) => event.preventDefault());
  dialog.addEventListener('keyup', (event) => {
    event.stopPropagation();
    if (event.key === 'Escape') dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('ak-guarantee-open');
    if (!opener?.isConnected) return;
    if (parentDialog?.isConnected && parentDialog.getClientRects().length && typeof trapFocus === 'function') {
      trapFocus(parentDialog, opener);
    } else {
      opener.focus();
    }
  });

  document.querySelectorAll('[data-ak-guarantee-open]').forEach((link) => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', dialog.id);
  });
})();
